import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import PrivacyPolicy from "./privacyPolicy";
import Home from "./Home";
import Contact from "./contactSection";
import Install from "./install";
import SubscriptionAgreement from "./subscriptionAgreement";
import RequestAccess from "./requestAccess";
import ArgusExportGuide from "./argusExportGuide";
import TrustDownloadGuide from "./trustDownloadGuide";
import ItSecurity from "./itSecurity";
import Auth from "./auth";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Navigate to="/" replace />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/install" element={<Install />} />
            <Route
              path="/subscription-agreement"
              element={<SubscriptionAgreement />}
            />
            <Route path="/request-access" element={<RequestAccess />} />
            <Route path="/request-access/:accessCode" element={<RequestAccess />} />
            <Route path="/argus-export-guide" element={<ArgusExportGuide />} />
            <Route path="/trusting-the-download" element={<TrustDownloadGuide />} />
            <Route path="/it-security" element={<ItSecurity />} />
            <Route path="/auth" element={<Auth />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
